import React from 'react';
import PropTypes from 'prop-types';
import { map, filter, isEqual, find } from 'lodash';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Loading from '../Loading';
import { renderIconButton } from '../MaterialMUIComponent';
import useTimeStore from '../ZustandProvider';

import Annotations from '../../../api/Annotations/Annotations';
import Videos from '../../../api/Videos/Videos';
import * as videoOps from '../../../api/Videos/video-operations';
import * as annotationsOps from '../../../api/Annotations/annotation-operations';

let indexRender = 0;
const MIN_RENDER_INICIALIZE = 0;
const ViewGeometriesOnMap = ({
  loading,
  videos,
  annotations,
  viewButtonGeometry,
  viewButtonCenter,
  startShowGeometries,
  startCenterGeometries,
  videoSelected,
  selectedAnnotation,
  handleAnnotation
}) => {
  if (loading) return <Loading />;
  const setShowNotesOnMap = useTimeStore(state => state.setShowNotesOnMap);
  const showNotesOnMap = useTimeStore(state => state.showNotesOnMap);
  const { showEnable, updateMap, enableCenter } = showNotesOnMap;
  const [isStart, setIsStart] = React.useState(true);
  const searchIndexAnnotationOnMap = (newAnnot, vid) => {
    const annotationsVideo = filter(annotations, item =>
      isEqual(annotationsOps.getVideo(item), videoOps.getId(vid))
    );
    const indexAnnot = annotationsVideo.indexOf(
      find(annotationsVideo, annot =>
        isEqual(annotationsOps.getId(annot), annotationsOps.getId(newAnnot))
      )
    );
    handleAnnotation(newAnnot, indexAnnot);
  };
  const renderManyIconButtons = array =>
    map(
      array,
      item =>
        item.isShow &&
        renderIconButton({
          key: item.key,
          onClick: item.onClick,
          icon: item.icon,
          titleTooltip: item.title,
          disabled: item.disabled,
          moreProps: { ...item.moreProps }
        })
    );
  React.useEffect(() => {
    setShowNotesOnMap({
      ...showNotesOnMap,
      updateMap: !updateMap,
      videos,
      annotations,
      selectVideo: videoSelected,
      selectAnnotation: selectedAnnotation,
      showEnable: startShowGeometries,
      enableCenter: startCenterGeometries,
      handleAnnotation: searchIndexAnnotationOnMap
    });
  }, []);

  React.useEffect(() => {
    if (!isStart)
      setShowNotesOnMap({
        ...showNotesOnMap,
        updateMap: !updateMap,
        videos,
        annotations,
        selectVideo: videoSelected,
        selectAnnotation: selectedAnnotation
      });
    if (isStart && indexRender >= MIN_RENDER_INICIALIZE) setIsStart(false);
    if (isStart) indexRender += 1;
  }, [videoSelected, selectedAnnotation]);

  return (
    <>
      {renderManyIconButtons([
        {
          isShow: viewButtonGeometry && !showEnable,
          key: 'boton-show-geometries',
          onClick: () =>
            setShowNotesOnMap({
              ...showNotesOnMap,
              showEnable: true,
              updateMap: !updateMap
            }),
          icon: (
            <VisibilityOffIcon
              style={{
                color: 'white'
              }}
            />
          ),
          titleTooltip: 'Show Geometries',
          disabled: false
        },
        {
          isShow: viewButtonGeometry && showEnable,
          key: 'boton-show-geometries',
          onClick: () =>
            setShowNotesOnMap({
              ...showNotesOnMap,
              showEnable: false,
              updateMap: !updateMap
            }),
          icon: (
            <VisibilityIcon
              style={{
                color: 'white'
              }}
            />
          ),
          titleTooltip: 'Hidden Geometries',
          disabled: false
        },
        {
          isShow: viewButtonCenter && enableCenter,
          key: 'boton-center-geometries',
          onClick: () =>
            setShowNotesOnMap({
              ...showNotesOnMap,
              enableCenter: !enableCenter,
              updateMap: !updateMap
            }),
          icon: (
            <LocationOnIcon
              style={{
                color: 'white'
              }}
            />
          ),
          titleTooltip: 'Center Geometries',
          disabled: false
        },
        {
          isShow: viewButtonCenter && !enableCenter,
          key: 'boton-center-geometries',
          onClick: () =>
            setShowNotesOnMap({
              ...showNotesOnMap,
              enableCenter: !enableCenter,
              updateMap: !updateMap
            }),
          icon: (
            <LocationOffIcon
              style={{
                color: 'white'
              }}
            />
          ),
          titleTooltip: 'Center Geometries',
          disabled: false
        }
      ])}
    </>
  );
};

ViewGeometriesOnMap.defaultProps = {
  loading: false,
  videos: [],
  annotations: [],
  viewButtonGeometry: true,
  viewButtonCenter: true,
  startShowGeometries: false,
  startCenterGeometries: false,
  videoSelected: {},
  selectedAnnotation: {},
  handleAnnotation: () => {}
};
ViewGeometriesOnMap.propTypes = {
  loading: PropTypes.bool,
  videos: PropTypes.array,
  annotations: PropTypes.array,
  viewButtonGeometry: PropTypes.bool,
  viewButtonCenter: PropTypes.bool,
  startShowGeometries: PropTypes.bool,
  startCenterGeometries: PropTypes.bool,
  videoSelected: PropTypes.object,
  selectedAnnotation: PropTypes.object,
  handleAnnotation: PropTypes.func
};

export default withTracker(
  ({ videosId, showAnnotations, showTrack, showAllAnnotations, showAllTracks, videoSelected }) => {
    const videosSub = Meteor.subscribe('manyvideos.annotations', videosId);
    const isReady = videosSub.ready();
    let videos = null;
    let annotations = null;

    const videosToSearch = showAllTracks ? videosId : [videoOps.getId(videoSelected)];
    const annotationsToSearch = showAllAnnotations ? videosId : [videoOps.getId(videoSelected)];
    if (isReady) {
      videos = Videos.find(
        {
          _id: { $in: videosToSearch },
          deleted: { $eq: 'no' }
        },
        { fields: { track: 1, coordinatesDataType: 1, latLng0: 1 } }
      ).fetch();
      annotations = Annotations.find(
        { 'geoJSON.properties.video': { $in: annotationsToSearch } },
        { sort: { videoTime: 1 } }
      ).fetch();
    }

    return {
      loading: !isReady,
      videos: showAllTracks || showTrack ? videos : [],
      annotations: showAnnotations || showAllAnnotations ? annotations : []
    };
  }
)(ViewGeometriesOnMap);
